import { cn } from "../../lib/utils";

export function Skeleton({ className }: { className?: string }): JSX.Element {
  return <div className={cn("h-4 w-full animate-pulse rounded bg-slate-100", className)} />;
}
